"use client";

import { FileText } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const clausesData = [{
  id: "clause-1.0",
  number: "1.0",
  title: "Liability & Asset Protection",
  content: "Standard liability is limited to $0.50 per pound unless a higher valuation is declared and additional insurance premiums are paid. All high-value assets exceeding $50,000 must be verified by our internal audit team prior to dispatch. Coverage excludes losses due to inherent vice or insufficient packaging by the consignor."
}, {
  id: "clause-2.0",
  number: "2.0",
  title: "RFQ Coordination & Vessel Connection",
  content: "Venchandlers Nexus acts as a digital intermediary connecting vessels with independent suppliers. We facilitate the RFQ process and procurement coordination but do not provide transit guarantees. All delivery schedules are managed by the chosen third-party providers and are subject to their specific operational terms."
}, {
  id: "clause-3.0",
  number: "3.0",
  title: "Customs & Regulatory Compliance",
  content: "Shippers are responsible for providing accurate documentation for international transit. We act as a facilitator for customs clearance but assume no liability for seizures or fines resulting from misclassification. All shipments must comply with the harmonized tariff schedule and relevant export control regulations."
}, {
  id: "clause-4.0",
  number: "4.0",
  title: "Service Scope Exclusions",
  content: "Our service does not transport cargo, operate warehouses, or maintain physical storage facilities. We exclude all liability for cargo handling, cold chain integrity, or logistics execution performed by third-party suppliers. Our role is strictly limited to the digital coordination of procurement inquiries and supplier matching."
}, {
  id: "clause-5.0",
  number: "5.0",
  title: "Force Majeure & Continuity",
  content: "Operations may be suspended without penalty in the event of labor strikes, natural disasters, or geopolitical unrest. We maintain a robust business continuity plan with redundant routing options. Liability for service interruptions is limited to the refund of freight charges for the affected segment."
}];
export default function DetailedClauses() {
  return <section data-section-id="120255" id="detailed-terms" className="bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {}
          <div className="lg:col-span-4 lg:sticky lg:top-24">
            <div className="inline-flex items-center justify-center p-3 bg-accent/10 rounded-sm mb-6 shadow-none">
              <FileText className="size-6 text-primary" />
            </div>
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight mb-4 font-serif text-foreground">
              Master Service Agreement
            </h2>
            <p className="text-muted-foreground mb-8 font-sans leading-[1.6] text-base md:text-lg">
              Venchandlers Nexus is a platform that connects vessels with independent suppliers and facilitates RFQ coordination. We do not transport cargo, operate warehouses, or guarantee delivery times, acting as a dedicated bridge for maritime procurement.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild variant="default" className="w-full sm:w-auto font-mono rounded-sm">
                <Link to="/PrivacyPolicyPage">Accept Terms</Link>
              </Button>
              <Button asChild variant="outline" className="w-full sm:w-auto font-mono rounded-sm">
                <Link to="/GlobalNetworkPage">Global Network</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full space-y-8">
              {clausesData.map((clause, i) => <AccordionItem key={clause.id} value={clause.id} data-index={i} className="group border border-border rounded-sm bg-card data-[state=open]:bg-accent/5 data-[state=open]:shadow-none transition-all duration-300 hover:border-l-primary hover:bg-accent/5 overflow-hidden">
                  <AccordionTrigger className="px-5 md:px-6 py-5 hover:no-underline">
                    <div className="flex items-center gap-4 text-left">
                      <Badge className="bg-transparent hover:bg-transparent text-primary border-none rounded-none px-0 py-0 text-xs font-mono font-bold tracking-widest shadow-none shrink-0">
                        SEC {clause.number}
                      </Badge>
                      <h3 className="font-serif text-base md:text-lg font-semibold text-foreground m-0 leading-tight">
                        {clause.title}
                      </h3>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-5 md:px-6 pb-6 pt-0">
                    <div className="pt-4 border-t border-border/20">
                      <p className="font-sans text-sm md:text-base text-muted-foreground leading-[1.6]">
                        {clause.content}
                      </p>
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}